import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
Vue.use(Router)




export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/kiosk',
      name: 'kiosk',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/Kiosk.vue')
    },
    {
      path: '/skeleton',
      name: 'skeleton',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/skeleton.vue')
    },
    {
      path: '/contact-us',
      name: 'contactus',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/ContactUs.vue')
    },
  
    {
      // RENTAL LIST 
      path: '/rental-list/:cate',
      name: 'rental-list',
      component: () => import('./views/RentalList.vue')
    },
    
    {
      // RENTAL LIST 
      path: '/search/:searchtext',
      name: 'search',
      component: () => import('./views/Search.vue')
    },
    {
      // RENTAL LIST 
      path: '/product-detail/:groupid',
      name: 'product-detail',
      component: () => import('./views/ProductDetail.vue')
    },

    {
      // WINTERSHOP
      path: '/aboutus',
      name: 'Aboutus',
      component: () => import('./views/Aboutus.vue')
    },
    {
      // WINTERSHOP
      path: '/test',
      name: 'Test',
      component: () => import('./views/Test.vue')
    },
    {
      // How to rent
      path: '/howtorent',
      name: 'howtorent',
      component: () => import('./views/Howtorent.vue')
    },
    {
      // FAQ
      path: '/faq',
      name: 'faq',
      component: () => import('./views/Faq.vue')
    },
    {
      // cart
      path: '/cart',
      name: 'cart',
      component: () => import('./views/Cart.vue')
    },
    {
      // cart
      path: '/confirm',
      name: 'confirm',
      component: () => import('./views/Confirm.vue')
    },
    {
      // cart
      path: '/complete',
      name: 'complete',
      component: () => import('./views/Complete.vue')
    },
    {
      // FAQ
      path: '/checkout',
      name: 'checkout',
      component: () => import('./views/Checkout.vue')
    },


  ]
})